import { z } from "zod";
import { EpochMillisSchema } from "./common.js";
export const ShopProductKindSchema = z.enum(["tokens", "grade", "subscription"]);
export const ShopProductSchema = z.object({
    id: z.string().min(1).max(80),
    kind: ShopProductKindSchema,
    categoryId: z.string().min(1).max(80).optional(),
    title: z.string().min(1).max(120),
    subtitle: z.string().min(1).max(180),
    description: z.string().min(1).max(500),
    priceCents: z.number().int().nonnegative(),
    currency: z.literal("EUR").default("EUR"),
    recurring: z.boolean().default(false),
    popular: z.boolean().default(false),
    badge: z.string().max(64).optional(),
    image: z.string().min(1).max(120),
    benefits: z.array(z.string().min(1).max(180)).default([]),
    rewardSummary: z.array(z.string().min(1).max(120)).default([]),
    tokens: z.number().int().nonnegative().optional(),
    gradeId: z.string().min(1).max(64).optional(),
});
export const ShopCategorySchema = z.object({
    id: z.string().min(1).max(80),
    label: z.string().min(1).max(80),
    description: z.string().max(300).default(""),
    sortOrder: z.number().int().default(0),
    active: z.boolean().default(true),
    createdAt: EpochMillisSchema.default(0),
    updatedAt: EpochMillisSchema.default(0),
});
export const AdminShopProductSchema = ShopProductSchema.extend({
    active: z.boolean().default(true),
    sortOrder: z.number().int().default(0),
    createdAt: EpochMillisSchema.default(0),
    updatedAt: EpochMillisSchema.default(0),
});
export const ShopCatalogSchema = z.object({
    products: z.array(ShopProductSchema),
    categories: z.array(ShopCategorySchema).default([]),
    stripeConfigured: z.boolean(),
    publishableKey: z.string().max(255).optional(),
});
export const AdminShopCatalogSchema = z.object({
    products: z.array(AdminShopProductSchema),
    categories: z.array(ShopCategorySchema),
});
export const AdminShopCategoryUpsertReqSchema = ShopCategorySchema.omit({
    createdAt: true,
    updatedAt: true,
});
export const AdminShopProductUpsertReqSchema = AdminShopProductSchema.omit({
    createdAt: true,
    updatedAt: true,
});
export const ShopCheckoutReqSchema = z.object({
    productId: z.string().min(1).max(80),
});
export const ShopCheckoutResSchema = z.object({
    checkoutUrl: z.string().url(),
    sessionId: z.string().min(1),
});
export const AdminStripeSettingsSchema = z.object({
    publishableKey: z.string().max(255).default(""),
    secretKeyConfigured: z.boolean().default(false),
    secretKeyLast4: z.string().max(8).nullable().default(null),
    webhookSecretConfigured: z.boolean().default(false),
    successUrl: z.string().max(512).default(""),
    cancelUrl: z.string().max(512).default(""),
    updatedAt: EpochMillisSchema.default(0),
});
export const AdminStripeSettingsUpdateReqSchema = z.object({
    publishableKey: z.string().max(255).default(""),
    secretKey: z.string().max(255).default(""),
    clearSecretKey: z.boolean().default(false),
    webhookSecret: z.string().max(255).default(""),
    clearWebhookSecret: z.boolean().default(false),
    successUrl: z.string().max(512).default(""),
    cancelUrl: z.string().max(512).default(""),
});
//# sourceMappingURL=shop.js.map